import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './hooks/useTheme';
import { initializeAccessibility } from './utils/accessibility';
import './index.css';

// Initialize accessibility features
initializeAccessibility();

// Add theme script to prevent flash of unstyled content
const themeScript = document.createElement('script');
themeScript.textContent = `
  (function() {
    const THEME_STORAGE_KEY = 'edge-commerce-theme';
    const THEME_ATTRIBUTE = 'data-theme';
    
    function getSystemTheme() {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    
    function getStoredTheme() {
      try {
        return localStorage.getItem(THEME_STORAGE_KEY);
      } catch {
        return null;
      }
    }
    
    function getEffectiveTheme() {
      const stored = getStoredTheme();
      if (stored === 'light' || stored === 'dark') {
        return stored;
      }
      return getSystemTheme();
    }
    
    const theme = getEffectiveTheme();
    document.documentElement.setAttribute(THEME_ATTRIBUTE, theme);
    
    // Mark as loaded to prevent flash
    document.documentElement.classList.add('loaded');
  })();
`;
document.head.appendChild(themeScript);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
